// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedIolLoop_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.0513 9.11092C5.33498 8.65103 3.57081 9.66958 3.11092 11.3859 2.65103 13.1022 3.66958 14.8664 5.3859 15.3263L4.86826 17.2581C2.08501 16.5124.433299 13.6515 1.17907 10.8683 1.92484 8.08501 4.78568 6.4333 7.56894 7.17907L7.0513 9.11092ZM17 12.0535C17 14.8149 14.7614 17.0535 12 17.0535 9.23858 17.0535 7 14.8149 7 12.0535 7 9.29204 9.23858 7.05347 12 7.05347 14.7614 7.05347 17 9.29204 17 12.0535ZM20.8879 12.9256C20.428 14.6419 18.6639 15.6605 16.9476 15.2006L16.4299 17.1324C19.2132 17.8782 22.074 16.2265 22.8197 13.4433 23.5655 10.66 21.9138 7.79923 19.1306 7.05347L18.6129 8.98532C20.3292 9.4452 21.3478 11.2093 20.8879 12.9256Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedIolLoop is a generated icon component.
 */
let IconMedIolLoop = IconMedIolLoop_1 = class IconMedIolLoop extends IconBaseElement {
    render() {
        return html `${IconMedIolLoop_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedIolLoop.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedIolLoop = IconMedIolLoop_1 = __decorate([
    customElement('zui-icon-med-iol-loop')
], IconMedIolLoop);
export { IconMedIolLoop };
